import { jsx as _jsx } from "react/jsx-runtime";
import { LoadingSpinner } from '../../../components/base';
import { AppRedirectPageWrapper } from '../AppRedirectPage/styles';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { makeSelectOrg } from '../../Root/selectors';
import { Redirect } from 'react-router-dom';
var OrgRedirectPage = function () {
    var history = useHistory();
    var org = useSelector(makeSelectOrg());
    var tokenAsQuery = new URLSearchParams(history.location.search).get('token');
    var existingToken = localStorage.getItem('token');
    return (!tokenAsQuery || (tokenAsQuery && existingToken === tokenAsQuery)) &&
        org &&
        org.selectedOrganizationId !== '' ? (_jsx(Redirect, { to: "/organizations/".concat(org.selectedOrganizationId, "/apps") })) : (_jsx(AppRedirectPageWrapper, { children: _jsx(LoadingSpinner, {}) }));
};
export default OrgRedirectPage;
